import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import WhatsAppFloat from "./components/layout/WhatsAppFloat";
import HomePage from "./components/pages/HomePage";
import AboutPage from "./components/pages/AboutPage";
import ContactPage from "./components/pages/ContactPage";
import MachiningCapabilities from "./components/pages/services/MachiningCapabilities";
import IndustryServed from "./components/pages/services/IndustryServed";
import QualityTesting from "./components/pages/services/QualityTesting";
import RawMaterials from "./components/pages/services/RawMaterials";
import "./App.css";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Router>
      <div className="App">
        <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route
            path="/services/machining-capabilities"
            element={<MachiningCapabilities />}
          />
          <Route
            path="/services/industry-served"
            element={<IndustryServed />}
          />
          <Route
            path="/services/quality-testing"
            element={<QualityTesting />}
          />
          <Route path="/services/raw-materials" element={<RawMaterials />} />
        </Routes>

        <Footer />
        <WhatsAppFloat />
      </div>
    </Router>
  );
}

export default App;
